import type { RouteRecordRaw } from 'vue-router'
// import {Payment} from '../../pages/Payment.vue'


// import { Payment } from '../../pages/Payment.vue';
import PaymentSuccess from '../../pages/PaymentSuccess.vue';
import { ROUTES } from '@myorg/type-lib'

export const paymentSuccessRoute: RouteRecordRaw = {
  path: ROUTES.PAYMENT_SUCCESS.PATH,
  name: ROUTES.PAYMENT_SUCCESS.NAME,
  component: PaymentSuccess,
}
